import { Inject } from '@angular/core';
import '@angular/compiler';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalAgentFullpageComponent } from './portal.agent.fullpage/portal.agent.fullpage.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalBoardListComponent } from './portal.board.list/portal.board.list.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageNotificationsComponent } from './page.notifications/page.notifications.component';
import { PortalBoardEditorComponent } from './portal.board.editor/portal.board.editor.component';
import { PortalAgentChatbotComponent } from './portal.agent.chatbot/portal.agent.chatbot.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalAgentSidebarComponent } from './portal.agent.sidebar/portal.agent.sidebar.component';
import { PageStorageComponent } from './page.storage/page.storage.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalMemberListComponent } from './portal.member.list/portal.member.list.component';
import { PortalAuthRegisterComponent } from './portal.auth.register/portal.auth.register.component';
import { PortalMemberProfileComponent } from './portal.member.profile/portal.member.profile.component';
import { PortalBoardLoadingComponent } from './portal.board.loading/portal.board.loading.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalBoardPaginationComponent } from './portal.board.pagination/portal.board.pagination.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalAuthLoginComponent } from './portal.auth.login/portal.auth.login.component';
import { PortalBoardDetailComponent } from './portal.board.detail/portal.board.detail.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        LayoutEmptyComponent,
        PagePostsItemComponent,
        PortalAgentFullpageComponent,
        LayoutSidebarComponent,
        PortalPostListComponent,
        PortalPostDetailComponent,
        PortalSeasonTreeComponent,
        PortalBoardListComponent,
        ComponentNavSidebarComponent,
        PageNotificationsComponent,
        PortalBoardEditorComponent,
        PortalAgentChatbotComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAccessComponent,
        PortalSeasonModalComponent,
        PortalAgentSidebarComponent,
        PageStorageComponent,
        PortalSeasonFormDropdownComponent,
        PortalMemberListComponent,
        PortalAuthRegisterComponent,
        PortalMemberProfileComponent,
        PortalBoardLoadingComponent,
        PortalSeasonPaginationComponent,
        PageMypageComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalBoardPaginationComponent,
        PageMembersComponent,
        PortalAuthLoginComponent,
        PortalBoardDetailComponent,
        PagePostsComponent,
        PageDashboardComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }